import * as $ from "jquery";
import _ from 'underscore';
import Tracking from "../../common/tracking";

export default class CombinedBundles {

  constructor() {

    const COMBINED_BUNDLE_JSW =
      {name: "Jira Software", feature: "Agile project management", bundles:[
          {name:"", feature:"", isPopular: false, value: "jira-software"},
          {name: "Confluence", feature: "documentation", isPopular: true, value: "jira-software-confluence"},
          {name: "Jira Service Desk", feature: "IT service management", isPopular: false, value: "jira-software-jira-service-desk"}
        ]};

    const COMBINED_BUNDLE_CONFLUENCE =
      {name: "Confluence", feature: "Document collaboration", bundles:[
          {name:"", feature:"", isPopular: false, value: "confluence"},
          {name: "Jira Software", feature: "agile project management", isPopular: true, value: "confluence-jira-software"},
          {name: "Jira Service Desk", feature: "IT service management", isPopular: false, value: "confluence-jira-service-desk"}
        ]};

    const COMBINED_BUNDLE_JIRA_CORE =
      {name: "Jira Core", feature: "Business project management", bundles:[
          {name:"", feature:"", isPopular: false, value: "jira-core"},
          {name: "Confluence", feature: "documentation", isPopular: true, value: "jira-core-confluence"},
        ]};

    const COMBINED_BUNDLE_JSD =
      {name: "Jira Service Desk", feature: "IT service management", bundles:[
          {name:"", feature:"", isPopular: false, value: "jira-service-desk"},
          {name: "Confluence", feature: "documentation collaboration", isPopular: true, value: "jira-service-desk-confluence"},
        ]};

    const COMBINED_BUNDLE = {
      "jira-software": COMBINED_BUNDLE_JSW,
      "confluence": COMBINED_BUNDLE_CONFLUENCE,
      "jira-core": COMBINED_BUNDLE_JIRA_CORE,
      "jira-service-desk": COMBINED_BUNDLE_JSD
    }

    return {

      renderCombinedBundlesForm: function () {

        // url health check
        var urlParams = new URLSearchParams(window.location.search);
        if (!urlParams.get("edition") || urlParams.get("edition").toLocaleLowerCase() !== 'free') {
          window.location.href = '/try/cloud/signup' +  window.location.search;
          Tracking.trackAll(
            "cart-cloud",
            "Invalid Edition Redirect",
            "combined-bundles-signup-page",
            { selectedEdition: urlParams.get("edition") },
            false
          );
        }

        // get bundle information
        var bundle = this.getBundle();

        // Hide the full signup form
        const fullForm = $('.trial-info-data.combined-bundles');
        fullForm.detach();
        fullForm.addClass('hidden');

        // Construct the new combined bundle form from template
        const combinedBundleFormTemplate = _.template($('.template--cloud-combined-bundle-feature-list').html());
        const newForm = $('<div />');
        newForm
          .append(combinedBundleFormTemplate({ combinedBundles: COMBINED_BUNDLE[bundle] }))
          .insertAfter('.imkt--cloud-signup .trial-info-data-combined-bundle');

        // set first focus and urls when user land or refresh on the page
        this.setFirstFocus();
        this.resetDownloadLink();

        // additional UI changers
        this.additionalUIChanges();


      },

      getBundle: function () {
        var bundle = new URLSearchParams(window.location.search).get("bundle");
        if ( bundle === "confluence" || bundle === "confluence-jira-software" || bundle === "confluence-jira-service-desk"){
          return "confluence";
        }
        else if ( bundle === "jira-core" || bundle === "jira-core-confluence") {
          return "jira-core";
        }
        else if ( bundle === "jira-service-desk" || bundle === "jira-service-desk-confluence" ) {
          return "jira-service-desk";
        }
        else {
          return "jira-software";
        }
      },

      setFirstFocus: function () {
        var bundle = new URLSearchParams(window.location.search).get("bundle");
        if (bundle === "confluence-jira-software" || bundle === "jira-software-confluence" || bundle === "jira-core-confluence" || bundle === "jira-service-desk-confluence" ){
          $('input[name="bundles[1]"]').parent().addClass("selected");
          $('.combined-bundle-products:nth-child(2)').addClass("selected");
        }
        else if ( bundle === "confluence-jira-service-desk" || bundle === "jira-software-jira-service-desk") {
          $('input[name="bundles[2]"]').parent().addClass("selected");
          $('.combined-bundle-products:nth-child(3)').addClass("selected");
        }
        else {
          $('input[name="bundles[0]"]').parent().addClass("selected");
          $('.combined-bundle-products:first-child').addClass("selected");
        }
      },

      resetDownloadLink: function () {
        var bundle = new URLSearchParams(window.location.search).get("bundle");
        var downloadLinkId = '#host_on_server_link_download';
        if ( bundle === "confluence" ){
          $(downloadLinkId).prop('href', "/software/confluence/download");
        }
        else if ( bundle === "jira-core") {
          $(downloadLinkId).prop('href', "/software/jira/core/download");
        }
        else if ( bundle === "jira-service-desk"  ) {
          $(downloadLinkId).prop('href', "/software/jira/service-desk/download");
        }
        else if (bundle === "jira-software-confluence" || bundle === "jira-software-jira-service-desk" ||
          bundle === "jira-core-confluence" ||
          bundle === "jira-service-desk-confluence" ||
          bundle === "confluence-jira-software" || bundle === "confluence-jira-service-desk"){
          $(downloadLinkId).prop('href', "/download");
        }
        else {
          $(downloadLinkId).prop('href', "/software/jira/download");
        }
      },

      additionalUIChanges: function () {
        var bundle = new URLSearchParams(window.location.search).get("bundle");
        if (bundle === "jira-service-desk") {
          $('.trial-info-data__features-heading').html("Free for up to 3 agents");
        }
        if (bundle === "jira-core" || bundle === "jira-core-confluence") {
          $('#combined-bundles-bottom-feature-list').html("Accounts for 10 users &#183; 2 GB storage &#183; community support")
        }
        if ( bundle === "confluence" || bundle === "confluence-jira-software" || bundle === "confluence-jira-service-desk"){
          $('#host_on_server_link_pricing').prop("href", "/software/confluence/pricing#feature-comparison");
        }
        else if ( bundle === "jira-core" || bundle === "jira-core-confluence") {
          $('#host_on_server_link_pricing').prop("href", "/software/jira/core/pricing#feature-comparison");
        }
        else if ( bundle === "jira-service-desk" || bundle === "jira-service-desk-confluence" ) {
          $('#host_on_server_link_pricing').prop("href", "/software/jira/service-desk/pricing#feature-comparison");
        }
      }
    };
  }
}
